import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Layout from "@/components/Layout";
import StatusBadge from "@/components/StatusBadge";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Button } from "@/components/ui/button";

const STATUSES = ["", "draft", "submitted", "under_review", "more_info_requested", "recommended_for_approval", "approved", "rejected", "disbursement_pending", "active", "completed", "cancelled"];

export default function AdminApplications() {
  const [items, setItems] = useState([]);
  const [status, setStatus] = useState("");
  const [q, setQ] = useState("");

  const load = () => api.get("/applications", { params: status ? { status } : {} }).then((r) => setItems(r.data));
  useEffect(() => { load(); }, [status]);

  const filtered = items.filter((a) => !q || a.borrower_email?.toLowerCase().includes(q.toLowerCase()) || a.product_name?.toLowerCase().includes(q.toLowerCase()));

  return (
    <Layout>
      <div className="fade-in space-y-4">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
          <h1 className="text-2xl font-semibold tracking-tight" style={{fontFamily:'Outfit'}}>All applications</h1>
          <div className="flex flex-col sm:flex-row gap-2 sm:items-center">
            <Input placeholder="Search by email/product…" value={q} onChange={(e)=>setQ(e.target.value)} className="w-full sm:w-64" data-testid="admin-app-search"/>
            <Select value={status} onValueChange={(v)=>setStatus(v === "__all__" ? "" : v)}>
              <SelectTrigger className="w-full sm:w-52" data-testid="admin-app-status-filter"><SelectValue placeholder="All statuses"/></SelectTrigger>
              <SelectContent>
                <SelectItem value="__all__">All statuses</SelectItem>
                {STATUSES.filter(Boolean).map((s) => <SelectItem key={s} value={s}>{s.replaceAll('_',' ')}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
        </div>

        <Card className="rounded-xl border-slate-200"><CardContent className="p-0">
          {filtered.length === 0 ? <div className="px-6 py-10 text-center text-slate-500">No applications.</div> : (
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead className="bg-slate-50 text-xs uppercase tracking-widest text-slate-500">
                  <tr>
                    <th className="text-left px-4 py-2">Borrower</th>
                    <th className="text-left px-4 py-2">Product</th>
                    <th className="text-left px-4 py-2">Amount</th>
                    <th className="text-left px-4 py-2">Duration</th>
                    <th className="text-left px-4 py-2">Status</th>
                    <th className="text-left px-4 py-2">Created</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {filtered.map((a) => (
                    <tr key={a.id} className="border-t border-slate-100" data-testid={`admin-app-${a.id}`}>
                      <td className="px-4 py-2">{a.borrower_email}</td>
                      <td className="px-4 py-2">{a.product_name}</td>
                      <td className="px-4 py-2">${a.amount.toFixed(2)}</td>
                      <td className="px-4 py-2">{a.duration} {a.duration_unit}</td>
                      <td className="px-4 py-2"><StatusBadge status={a.status}/></td>
                      <td className="px-4 py-2">{new Date(a.created_at).toLocaleDateString()}</td>
                      <td className="px-4 py-2 text-right"><Link to={`/reviewer/applications/${a.id}`}><Button size="sm" variant="outline" data-testid={`admin-open-${a.id}`}>Open</Button></Link></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </CardContent></Card>
      </div>
    </Layout>
  );
}
